export const getState = (store = {}) => store;
export const getAuth = store => getState(store).auth;
export const getDbet = store => getState(store).dbet;
export const getPopup = store => getState(store).popup;
export const getError = store => getState(store).error;
export const getGames = store => getState(store).games;
export const getAuthLang = store => getAuth(store).lang;
export const getDialog = store => getState(store).dialog;
export const getErrorId = store => getError(store).errorId;
export const getPersist = store => getState(store).persist;
export const getUiState = store => getState(store).uiState;
export const getMetamaskIsWrongNetwork = store => getState(store).uiState.metamaskIsWrongNetwork;
export const getPopupWallet = store => getPopup(store).wallet;
export const getDbetData = store => getDbet(store).data || {};
export const getWalletName = store => getAuth(store).walletName;
export const getProviderData = store => getDbet(store).providerData;
export const getSignInStatus = store => getAuth(store).signInStatus;
export const getIsDbetLoaded = store => getDbet(store).dbetIsLoaded;
export const getAuthIsLoggedIn = store => getAuth(store).isLoggedIn;
export const getSelectedGame = store => getGames(store).selectedGame;
export const getBannersData = store => getState(store)?.banners?.data;
export const getGamesCategories = store => getGames(store).categories;
export const getAuthRestoreLogin = store => getAuth(store).restoreLogin;
export const getAuthUserSettings = store => getAuth(store).userSettings;
export const getGamesRTPWithID = store => getGames(store).gamesRTPWithID;
export const getSelectedGameId = store => getGames(store).selectedGameId;
export const getAuthLoadingStatus = store => getAuth(store).loadingStatus;
export const getPersistActiveFilter = store => getGames(store).activeFilter;
export const getGamesData = (store, filter) => getGames(store)[filter]?.data;
export const getGamesCount = (store, label) => getGames(store).counts?.[label];
export const getPersistFavoriteGames = store => getPersist(store).favoriteGames;
export const getCurrentTransaction = store => getDbet(store).currentTransaction;
export const getDbetTransactionResult = store => getDbet(store).transactionResult;
export const getDbetFinalTransaction = store => getDbet(store).finalTransaction;
export const getContractTransaction = store => getDbet(store).contractTransaction;
export const getAuthUserSettingsImage = store => getAuthUserSettings(store).image;
export const getDbetWaitForTransaction = store => getDbet(store).waitForTransaction;
export const getContractTransactionType = store => getContractTransaction(store).type;
export const getAuthUserSettingsAddress = store => getAuthUserSettings(store).address;
export const getAuthUserSettingsBalance = store => getAuthUserSettings(store).balance;
export const getDbetFinalTransactionSync = store => getDbetFinalTransaction(store).sync;
export const getUiStateNavigationSection = store => getUiState(store).navigationSection;
export const getAuthUserSettingsUsername = store => getAuthUserSettings(store).username;
export const getAuthUserSettingsLoginFinished = store => getAuthUserSettings(store).loginFinished;
export const getUiStateDepositTabIsActive = store => getUiState(store).depositTabIsActive;
export const getUiStateNavigationIsOpened = store => getUiState(store).navigationIsOpened;
export const getUiStateIsMobile = store => getUiState(store).isMobile;
export const getCurrentTheme = store => getUiState(store).theme;
export const getAuthUserSettingsHasChannel = store => getAuthUserSettings(store).hasChannel;
export const getAuthUserSettingsVerificationStatus = store =>
  getAuthUserSettings(store)?.verificationStatus;
export const getAuthUserSettingsNativeCurrencyBalance = store =>
  getAuthUserSettings(store)?.nativeCurrencyBalance;
export const getGamesCategoriesLoadingStatus = store => getGames(store).categoriesLoadingStatus;
export const getGamesDataLoadingStatus = (store, filter) => getGames(store)[filter]?.loadingStatus;
export const getBannersDataLoadingStatus = store => getState(store)?.banners?.bannersLoadingStatus;
export const getAuthUserSettingsChannelAddress = store => getAuthUserSettings(store).channelAddress;
export const getAuthUserSettingsChannelBalance = store => getAuthUserSettings(store).channelBalance;
export const getDbetTransactionResultDeposit = store => getDbetTransactionResult(store).deposit;
export const getDbetWaitForTransactionSync = store => getDbetWaitForTransaction(store).sync;
export const getDbetWaitForTransactionSendTo = store => getDbetWaitForTransaction(store).sendTo;
export const getDbetWaitForTransactionDeposit = store => getDbetWaitForTransaction(store).deposit;
export const getDbetWaitForTransactionWithdraw = store => getDbetWaitForTransaction(store).withdraw;
export const getDbetWaitForTransactionCreateChannel = store =>
  getDbetWaitForTransaction(store).channelCreate;
export const getFavoriteGames = store => getGames(store).Favorites;
export const getFavoriteGamesData = store => getFavoriteGames(store).data;

export const getDbetWaitForTransactionPrepareWithdraw = store =>
  getDbetWaitForTransaction(store).prepareWithdraw;

export const getDbetWaitForTransactionCancelWithdraw = store =>
  getDbetWaitForTransaction(store).cancelWithdraw;

export const getPersistHasFavoriteGames = (store, externalGameId) =>
  getFavoriteGamesData(store).some(game => game.externalGameId === externalGameId);
